// extracted by mini-css-extract-plugin
export default {"Character":"Character_Character__ucuhX"};